// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:49:12

export default {
  "id": "jello-bubbles",
  "slug": "jello-bubbles",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/30ce0d14d86d4ebe9da67c6eaeedd83a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/30ce0d14d86d4ebe9da67c6eaeedd83a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Jello Bubbles",
      "description": "Classic Match 3 Bubble Shooter Game with jello balls, challenges, a nice bird and a fantastic heroine. Enjoy with lots of fun levels travelling around the world.",
      "instructions": "Match 3 or more bubbles with the same color and clear levels, accomplish the game objective to advance to the next one. \n\nAim & shoot with the Jell-O-Matic Machine ®, to drop & blast all bubbles.  A funny hummingbird helps you with nice boosters.   Click on the screen and drag the mini bubbles aim and lift it to shot.  Take your time to aim and hit your desired bubble to make it pop.",
      "genres": [
        "Bubble Shooter",
        "Match-3"
      ],
      "tags": [
        "aim",
        "blast",
        "bubble",
        "match3",
        "travel"
      ]
    },
    "zh-CN": {
      "title": "果冻泡泡",
      "description": "经典匹配3泡泡射击游戏，带有果冻球、挑战、一只可爱的小鸟和一位了不起的女英雄。在全球各地旅行中享受众多有趣关卡。",
      "instructions": "匹配三个或更多相同颜色的气泡以清除关卡，完成游戏目标以进入下一关。\n\n使用Jell-O-Matic Machine®瞄准并射击，以掉落并爆破所有气泡。一只有趣的蜂鸟会提供不错的辅助道具。点击屏幕并拖动迷你气泡进行瞄准，将其提起并射击。慢慢瞄准，击中你想要的气泡使其爆裂。",
      "genres": [
        "泡泡射手",
        "三消游戏"
      ],
      "tags": [
        "瞄准",
        "爆破",
        "泡泡",
        "三消",
        "旅行"
      ]
    },
    "zh-TW": {
      "title": "果冻泡泡",
      "description": "經典的泡泡射手連環3匹配遊戲，有果冻球、挑戰、可愛的小鳥和迷人的女主角。享受各種有趣的水準，在世界各地旅遊。",
      "instructions": "匹配三顆或以上的相同顏色氣泡，清空關卡，完成遊戲目標以進入下一關。\n\n使用Jell-O-Matic Machine®進行瞄准與射擊，以降下並炸毀所有氣泡。一隻搞笑的蜂鳥會幫助你使用美妙的加強器。點擊屏幕並拖動迷你氣泡進行瞄准，再抬升它以射擊。慢慢對準目標，擊中你想要的氣泡使其破裂。",
      "genres": [
        "泡泡消消樂",
        "三消對戲"
      ],
      "tags": [
        "目標",
        "爆破",
        "泡泡",
        "三消",
        "旅行"
      ]
    },
    "zh-HK": {
      "title": "吉利泡泡",
      "description": "經典連線3泡泡射擊遊戲，配以果冻球、挑戰、可愛的鳥兒及絕佳的女主角。享受多個充滿樂趣的等級，環遊世界。",
      "instructions": "匹配三個或以上同色泡泡，清空關卡，達成遊戲目標以進入下一關。\n\n使用Jell-O-Matic Machine®進行瞄准及射擊，將所有泡泡降下並爆破。一隻有趣的蜂鳥會幫助你使用美妙的加強器。點擊螢幕並拖動迷你泡泡進行瞄准，再提升它以射擊。慢慢瞄准，擊中你想要的泡泡使其爆破。",
      "genres": [
        "泡泡射擊",
        "三合一大富翁"
      ],
      "tags": [
        "對準",
        "爆破",
        "泡泡",
        "三消遊戲",
        "旅行"
      ]
    },
    "ja": {
      "title": "ジェロ・バブルズ",
      "description": "ジェロボールを用いたクラシックマッチ3バブルシューターゲーム、チャレンジ、素敵な鳥、そして素晴らしいヒロイン。世界中を旅する楽しいレベルで楽しんでください。",
      "instructions": "同じ色の3つ以上の泡を合体させ、レベルをクリアして、次のレベルに進む。Jell-O-Matic Machine ®を使って、泡を落下させ、爆破する。面白い蜂の巣に助けてくれるハチドリが素晴らしいブースターを提供する。画面をタップして、ミニ泡を合体させ、リフトして発射する。ゆっくりと合体させ、狙いたい泡に当てて爆破する。",
      "genres": [
        "バブルシュータ",
        "マッチ3"
      ],
      "tags": [
        "標的を射撃",
        "爆破",
        "泡",
        "マッチ3",
        "旅行"
      ]
    },
    "ko": {
      "title": "젤로 부분링",
      "description": "클래식 매치 3 퍼플 샷터 게임, 젤리 볼, 도전 과제, 좋은 새와 fantastic 여주인공. 세계를 여행하면서 많은 재미 있는 레벨을 즐겨보세요.",
      "instructions": "3개 이상의 같은 색의 버블을 맞추어 레벨을 클리어하고, 게임 목표를 달성하여 다음 레벨로 진행하세요.\n\nJell-O-Matic Machine ®를 사용하여 목표를 정하고 발사하여 모든 버블을 떨어뜨리고 폭파하세요. 재미있는 흥미진진한 멧새가 나쁜 보스터를 도와줍니다. 화면을 클릭하고 미니 버블을 목표로 정하고 드래그하여 발사하세요. 정확히 맞추고자하는 버블을 선택하여 터뜨리기 위해 시간을 내세요.",
      "genres": [
        "버블슈터",
        "매치3"
      ],
      "tags": [
        "타겟",
        "폭발",
        "바블",
        "매치3",
        "여행"
      ]
    },
    "fr": {
      "title": "Gouttes de gélatine",
      "description": "Classique jeu de tir de bulles 3 en 1 avec des boules de gelée, des défis, un joli oiseau et une héroïne fantastique. Profitez de nombreux niveaux amusants en voyageant à travers le monde.",
      "instructions": "Association de 3 bulles ou plus de la même couleur pour clarifier les niveaux, accomplissez l'objectif du jeu pour passer au niveau suivant.\n\nViser et tirer avec la Machine à Gélatine ®, pour faire tomber et exploser toutes les bulles. Un oiseau-mouche amusant vous aide avec de bons boosters. Cliquez sur l'écran et faites glisser la bulle miniature pour viser et la lever pour tirer. Prenez votre temps pour viser et frapper la bulle souhaitée pour la faire exploser.",
      "genres": [
        "Pop Balle",
        "Correspondance 3-à-3"
      ],
      "tags": [
        "aim",
        "blast",
        "bulle",
        "match3",
        "voyage"
      ]
    }
  }
};
